import React, { useCallback } from 'react';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the sheet; each part uses its own slice of it */
import styles from './SMLCreationSheet.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CreationDateFieldProps {
  value: string;
  /** Earliest day the artist may pick, `YYYY-MM-DD`. */
  min: string;
  wide?: boolean;
  onChange: (value: string) => void;
}

/**
 * Release day, and only the day.
 *
 * The same browser date control the pre-save wizard uses, with the same floor
 * on today — but no time beside it. The design drew one; a campaign has no
 * hour in it anywhere, so a time field would be a promise the release job
 * cannot keep.
 */
const CreationDateFieldComponent: React.FC<CreationDateFieldProps> = ({ value, min, wide, onChange }) => {
  const intl = useIntl();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value),
    [onChange]
  );

  const label = intl.formatMessage({ id: 'app.sml.create.date.label', defaultMessage: 'Release date' });

  return (
    <div className={clsx(styles.field, wide === true && styles.fieldWide)}>
      <span className={styles.fieldLabel}>{label}</span>
      <Input type="date" min={min} value={value} aria-label={label} onChange={handleChange} />
      <span className={styles.fieldHelp}>
        {intl.formatMessage({
          id: 'app.sml.create.date.help',
          defaultMessage: 'What the countdown counts to. Nothing is saved until you mark it released.',
        })}
      </span>
    </div>
  );
};

export const CreationDateField = TypedMemo(CreationDateFieldComponent);
